
import { Options, Vue } from 'vue-class-component';
import { getError } from "@/utils/helpers";
import CoursePreview from "@/components/CoursePreview.vue";
import RegionListEntry from "@/components/RegionListEntry.vue";
import DataService from "@/services/DataService";
import RegionService from "@/services/RegionService";
import UrlService from "@/services/UrlService";
import AuthService from "@/services/AuthService";
import FieldError from "@/components/forms/FieldError.vue";
import NavigationService from "@/services/NavigationService";
import { Course } from "@/data/course";
import CourseService from "@/services/CourseService";

type Form = {
    prename: string,
    surname: string,
    email: string,
    phone_mobile: string,
    phone_mobile_confirmation: string,
    phone_home: string,
    known_through: string|null,
    known_through_custom: string,
    park_wish: string,
    consent_newsletter: boolean,
    consent_terms: boolean,
    consent_privacy: boolean,
    password: string,
    password_confirmation: string,
    region: number|null,
};

type Region = {
    id: number,
    name: string,
};

type FormErrors = Record<string, string[]>;

// type FormStep = 'region' | 'personals';

@Options({
    props: {
        /*preselectRegion: {
            type: Number,
            required: false,
            default: null,
        }*/
    },
    components: {
        FieldError,
        CoursePreview,
        RegionListEntry,
    },
})
export default class RegisterForm extends Vue {
    //preselectRegion?: number|null
    success = false

    appointmentPreselect: number|null = null
    coursePreselect: number|null = null
    regionPreselect: number|null = null
    regionLocked = false

    course: Course|null = null
    selectedAppointmentId: string|number|null = null

    loadingCourse = false
    loadingRegions = false
    loadingSubmit = false

    loadCourse() {
        if( !this.coursePreselect ) {
            return;
        }

        this.loadingCourse = true;
        return CourseService.getCourseForRegistration(this.coursePreselect).then(result => {
            this.course = result.data.data || null;
        }).finally(() => this.loadingCourse = false);
    }

    onAppointmentSelected(appointmentId: string|number) {
        console.log('appointmentId selected: ', appointmentId);
        this.selectedAppointmentId = appointmentId;
    }

    regionFilter = ''
    get regionFiltered() : Region[] {
        const search = this.regionFilter.trim().toLowerCase();
        if( search.length < 1 ) {
            return this.regions;
        }
        console.log('filtering...');
        return this.regions.filter(region => {
            return region.name.toLocaleLowerCase().indexOf(search) !== -1;
            //return search.localeCompare(region.name, undefined, {sensitivity: 'base'}) === 0;
        });
    }

    errors: FormErrors = {}

    get hasErrors() {
        return Object.keys(this.errors).length > 0;
    }

    form: Form = {
        prename: '',
        surname: '',
        email: '',
        phone_mobile: '',
        phone_mobile_confirmation: '',
        phone_home: '',
        known_through: null,
        known_through_custom: '',
        park_wish: '',
        consent_newsletter: false,
        consent_terms: false,
        consent_privacy: false,
        password: '',
        password_confirmation: '',
        region: null,
    }

    knownThroughValues: string[] = []
    regions: Region[] = []

    get formWithPreselectData() {
        return {
            ...this.form,
            known_through: (this.form.known_through || '').toLowerCase() === 'sonstiges' ? this.form.known_through_custom : this.form.known_through,
            course: this.course?.id || null,
            appointment: this.selectedAppointmentId || null,
            appointment_required: !!this.course && (this.course?.appointments_upcoming?.length || 0) > 0,
        };
    }

    submitForm() {
        this.errors = {};
        this.loadingSubmit = true;
        AuthService.registerUser(this.formWithPreselectData).then(() => {
            // this.loadingSubmit = false; // we do not do this in success case because we are redirecting the user (better UX)

            this.success = true;
            // this.errors = {};

            NavigationService.navigateRegisterSuccessful();
        }).catch(error => {
            this.loadingSubmit = false;

            //console.warn(error);
            //console.warn(getError(error));
            this.errors = getError(error);
        });
    }

    loadKnownFromValues() {
        return DataService.getRegister().then(result => {
            this.knownThroughValues = result.data.data.known_through_values || [];
        });
    }
    loadRegions() {
        return RegionService.getListForRegister().then(result => {
            this.regions = result.data.data || [];
        });
    }

    mounted() {
        this.loadKnownFromValues();

        const regionPreselect = UrlService.getUrlParameter('region');
        if( regionPreselect ) {
            this.regionLocked = true;
            //this.step = 'personals';
        }

        const appointmentPreselect = UrlService.getUrlParameter('appointment');
        if( appointmentPreselect ) {
            this.appointmentPreselect = parseInt(appointmentPreselect);
        }

        const promises = [];

        const coursePreselect = UrlService.getUrlParameter('course');
        if( coursePreselect ) {
            this.coursePreselect = parseInt(coursePreselect);
            promises.push(this.loadCourse()?.then(() => {
                if( this.course?.mode !== 0 ) {
                    console.warn('preselected course is not an open course, can not enroll during register');
                    this.coursePreselect = null;
                    this.course = null;
                    this.appointmentPreselect = null;
                }
            }));
        }

        this.loadingRegions = true;
        promises.push(this.loadRegions());
        Promise.allSettled(promises).then(() => {
            this.loadingRegions = false;
            if( this.coursePreselect ) {
                this.form.region = this.course?.region_id || null; // course will be loaded by now
                if( this.form.region ) {
                    this.regionLocked = true;
                }
            }
            else if( regionPreselect ) {
                this.form.region = parseInt(regionPreselect);
            }
        });
    }
}
